function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 11.5l-4-4V4h8v3.5l-4 4zM8 20v-3.5l4-4 4 4V20H8z",
  opacity: ".3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fillOpacity: ".87"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 2H6v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2zm-2 14.5V20H8v-3.5l4-4 4 4zm-8-9l4 4 4-4V4H8v3.5z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fillOpacity: ".87"
}));